import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { Fragment } from "react";
import SwipeableViews from "react-swipeable-views"; //Material imports

import { withStyles } from "@material-ui/core/styles"; //Limitless imports

import { ClientContext } from "../../../../common/utils";
import SlideItem from "../slide-item/SlideItem";
import SlideIndicator from "../slide-indicator/SlideIndicator";
import { TEXT_IMAGE_SLIDE } from "../../../utils/HowItWorksCardHelper";

var HowItWorksCarousel = function HowItWorksCarousel(_ref) {
  var classes = _ref.classes,
      theme = _ref.theme,
      slides = _ref.slides,
      mandatory = _ref.mandatory,
      onNavigate = _ref.onNavigate,
      isMobileDevice = _ref.isMobileDevice,
      onClose = _ref.onClose;

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      slideIndex = _React$useState2[0],
      setSlideIndex = _React$useState2[1];

  var navigate = function navigate() {
    if (mandatory && slideIndex !== slides.length - 1) {
      setSlideIndex(slideIndex + 1);
    } else {
      onNavigate();
    }
  };

  var slideKey = 0;
  var maxHeight = "550px"; //the size of the container is based on the first card.
  //this was done for mobile view which stretches

  if (slides[0] && slides[0].type === TEXT_IMAGE_SLIDE) {
    maxHeight = "unset";
  }

  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(SwipeableViews, {
    axis: theme.direction === "rtl" ? "x-reverse" : "x",
    index: slideIndex,
    onChangeIndex: setSlideIndex,
    className: classes.swipeableViewContainer,
    containerStyle: {
      maxHeight: maxHeight
    }
  }, slides.map(function (slide) {
    slideKey++;
    return /*#__PURE__*/React.createElement(SlideItem, {
      key: slideKey + 1,
      onButtonClickHandle: navigate,
      slideKey: slideKey,
      shouldAnimate: ClientContext._animation,
      slide: slide,
      isMobileDevice: isMobileDevice,
      onClose: onClose
    });
  })), /*#__PURE__*/React.createElement(SlideIndicator, {
    slideCount: slides.length,
    onSlideChange: function onSlideChange(event, value) {
      return setSlideIndex(value);
    },
    activeSlideIndex: slideIndex
  }));
};

var styles = {
  swipeableViewContainer: {
    flex: 1,
    display: "flex",
    height: "100%",
    alignItems: "center"
  },
  "@media screen and (min-width: 450px)": {
    swipeableViewContainer: {
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12
    }
  }
};
export default withStyles(styles, {
  withTheme: true
})(HowItWorksCarousel);
HowItWorksCarousel.defaultProps = {
  mandatory: true
};